class PredictiveSearch {
  constructor() {
    this.drawer = document.getElementById('AeSearchDrawer');
    this.triggers = document.querySelectorAll('.js-search-header-custom');
    this.closeButton = this.drawer?.querySelector('[data-search-drawer-close]');
    this.searchInput = this.drawer?.querySelector('[data-search-input]');
    this.clearButton = this.drawer?.querySelector('[data-search-clear]');
    this.resultsContainer = this.drawer?.querySelector('[data-results]');
    this.itemsContainer = this.drawer?.querySelector('[data-items]');
    this.loadingElement = this.drawer?.querySelector('[data-loading]');
    this.noResultsElement = this.drawer?.querySelector('[data-no-results]');
    this.viewAllButton = this.drawer?.querySelector('[data-view-all]');
    this.drawerOverlay = document.querySelector('.ae-drawer-overlay');
    this.searchFooter = this.drawer?.querySelector('.ae-predictive-search__footer');
    
    this.searchTimeout = null;
    this.isOpen = false;
    
    // Hide drawer and footer by default
    if (this.drawer) {
      this.drawer.style.display = 'none';
    }
    if (this.drawerOverlay) {
      this.drawerOverlay.style.display = 'none';
    }
    if (this.searchFooter) {
      this.searchFooter.style.display = 'none';
    }
    
    // Add search form submit handler
    this.viewAllButton?.addEventListener('click', (e) => {
      e.preventDefault();
      if (this.searchInput && this.searchInput.value.trim() !== '') {
        window.location.href = `/search?q=${encodeURIComponent(this.searchInput.value.trim())}`;
      }
    });
    
    this.init();
  }
  
  init() {
    if (!this.drawer) return;
    
    // Open search drawer
    this.triggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        this.openDrawer();
      });
    });
    
    // Close search drawer
    this.closeButton?.addEventListener('click', () => {
      this.closeDrawer();
    });
    
    // Handle click outside
    document.addEventListener('click', (e) => {
      if (this.isOpen && !this.drawer.contains(e.target) && !e.target.closest('.js-search-header-custom')) {
        this.closeDrawer();
      }
    });
    
    // Handle search input
    this.searchInput?.addEventListener('input', (e) => {
      const searchTerm = e.target.value;
      
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      if (searchTerm.length === 0) {
        this.clearResults();
        return;
      }
      
      this.showLoading();
      
      // Debounce search
      this.searchTimeout = setTimeout(() => {
        this.performSearch(searchTerm);
      }, 300);
    });
    
    // Clear search
    this.clearButton?.addEventListener('click', () => {
      if (this.searchInput) {
        this.searchInput.value = '';
        this.clearResults();
      }
    });
    
    // Update view all button URL
    this.searchInput?.addEventListener('change', (e) => {
      if (this.viewAllButton) {
        const searchTerm = e.target.value;
        this.viewAllButton.href = `${window.routes.search_url}?q=${encodeURIComponent(searchTerm)}`;
      }
    });
  }
  
  // openDrawer() {
  //   if (this.drawer) {
  //     this.drawer.style.display = 'block';
  //   }
  //   this.drawer.classList.add('is-active');
  //   if (this.drawerOverlay) {
  //     this.drawerOverlay.style.display = 'block';
  //   }
  //   this.drawerOverlay?.classList.add('is-active');
  //   document.body.style.overflow = 'hidden';
  //   this.isOpen = true;
    
  //   // Focus search input
  //   setTimeout(() => {
  //     this.searchInput?.focus();
  //   }, 100);
  // }

  openDrawer() {
    if (this.drawer) {
        this.drawer.removeAttribute("hidden");  
        this.drawer.style.display = 'block';
    }
    this.drawer.classList.add('is-active');
    
    if (this.drawerOverlay) {
        this.drawerOverlay.removeAttribute("hidden");  
        this.drawerOverlay.style.display = 'block';
    }
    this.drawerOverlay?.classList.add('is-active');

    document.body.style.overflow = 'hidden';
    this.isOpen = true;
    
    // Focus search input
    setTimeout(() => {
        this.searchInput?.focus();
    }, 100);
}
  
  closeDrawer() {
    this.drawer.classList.remove('is-active');
    this.drawerOverlay?.classList.remove('is-active');
    setTimeout(() => {
      if (this.drawer) {
        this.drawer.style.display = 'none';
      }
      if (this.drawerOverlay) {
        this.drawerOverlay.style.display = 'none';
      }
    }, 300); // Wait for transition to complete
    document.body.style.overflow = '';
    this.isOpen = false;
    this.clearResults();
    
    if (this.searchInput) {
      this.searchInput.value = '';
    }
  }
  
  showLoading() {
    if (this.loadingElement && this.resultsContainer && this.noResultsElement) {
      this.loadingElement.hidden = false;
      this.resultsContainer.hidden = true;
      this.noResultsElement.hidden = true;
    }
  }
  
  async performSearch(searchTerm) {
    try {
      const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(searchTerm)}&resources[type]=product`);
      const data = await response.json();
      
      this.loadingElement.hidden = true;
      
      if (data.resources.results.products.length > 0) {
        this.renderResults(data.resources.results.products);
      } else {
        this.showNoResults();
      }
    } catch (error) {
      console.error('Search error:', error);
      this.showNoResults();
    }
  }
  
  renderResults(products) {
    if (!this.itemsContainer || !this.resultsContainer || !this.noResultsElement) return;
    
    this.itemsContainer.innerHTML = products.map(product => `
      <a href="${product.url}" class="ae-predictive-search__item"> 
        <img src="${product.featured_image.url}" alt="${product.title}" loading="lazy" class="ae-predictive-search__item-image"> 
        <div class="ae-predictive-search__item-content">
          <h4 class="ae-predictive-search__item-title">${product.title}</h4>
        </div>
      </a>
    `).join('');
    
    this.resultsContainer.hidden = false;
    this.noResultsElement.hidden = true;
    // Only show footer when we have search results
    if (this.searchFooter && products.length > 0) {
      this.searchFooter.style.display = 'block';
    } else if (this.searchFooter) {
      this.searchFooter.style.display = 'none';
    }
  }
  
  showNoResults() {
    if (!this.resultsContainer || !this.noResultsElement) return;
    
    this.resultsContainer.hidden = true;
    this.noResultsElement.hidden = false;
    if (this.searchFooter) {
      this.searchFooter.style.display = 'none';
    }
  }
  
  clearResults() {
    if (!this.itemsContainer || !this.resultsContainer || !this.noResultsElement || !this.loadingElement) return;
    
    this.itemsContainer.innerHTML = '';
    this.resultsContainer.hidden = true;
    this.noResultsElement.hidden = true;
    this.loadingElement.hidden = true;
    if (this.searchFooter) {
      this.searchFooter.style.display = 'none';
    }
  }
}

// Initialize predictive search
window.addEventListener('DOMContentLoaded', () => {
  new PredictiveSearch();
}); 